import './axios'
import 'bootstrap'

import './vuetify'
import './googlesign'
import './vue-material'



// WEBPACK FOOTER //
// ./resources/js/plugins/index.js